import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-authors',
  templateUrl: './breadcrumb-authors.component.html',
  styleUrls: ['./breadcrumb-authors.component.scss']
})
export class BreadcrumbAuthorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
